import { Img, SubPageHeader } from "@/common/commonType";
import { createContext, useContext } from "react";

export type FooterInfo = {
    contact_us_title: SubPageHeader
    company_name: string
    introduction: string
    phone: string
    // fax: string
    email: string
    address: string
    service_hours: string
    follow_us: {
        qr_code: Img
        redirect_url: string
        desc: string
    }[]
    current_year: string
}

type FooterInfoContextType = {
    footerInfo: FooterInfo
}

export const FooterInfoContext = createContext<FooterInfoContextType>({
    footerInfo: {
        contact_us_title: {
            title: '',
            desc: ''
        },
        introduction: '',
        company_name: '',
        phone: '',
        // fax: '',
        email: '',
        address: '',
        service_hours: '',
        follow_us: [],
        current_year: ''
    }
});

export function useFooterInfo() {
  const context = useContext(FooterInfoContext);
  if (!context) {
    throw new Error('useFooterInfo must be used within a FooterInfoProvider');
  }
  return context;
}